module.exports = __webpack_public_path__ + "img/logo.d95b26b8.png";